import { render, staticRenderFns } from "./BaseViewFrame.vue?vue&type=template&id=67329e80&"
import script from "./BaseViewFrame.vue?vue&type=script&lang=js&"
export * from "./BaseViewFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ageo\\Documents\\Work\\fhapplication\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67329e80')) {
      api.createRecord('67329e80', component.options)
    } else {
      api.reload('67329e80', component.options)
    }
    module.hot.accept("./BaseViewFrame.vue?vue&type=template&id=67329e80&", function () {
      api.rerender('67329e80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/core/components/BaseViewFrame.vue"
export default component.exports